<template>
  <page>
    <template slot="content">
      <template>
        <list-group :title="'計測データ'">
          <list-item :spanText="'Q. '" :text="'睡眠や歩数がアプリに反映されない場合'" :urlName="'Help19'"></list-item>
          <list-item :spanText="'Q. '" :text="'WeBandの歩数がヘルスケアや他社製品と異なる原因'" :urlName="'Help22'"></list-item>
          <list-item :spanText="'Q. '" :text="'WeBandから計測データを取得する方法'" :urlName="'Help17'"></list-item>
        </list-group>
      </template>
    </template>
  </page>
</template>

<script>
  import ListGroup from '@/components/ListGroup'
  import ListItem from '@/components/ListItem'
  import Tab from '@/components/Tab'
  import TabBtn from '@/components/TabBtn'
  import TabContent from '@/components/TabContent'
  import Page from '@/components/Page'

  export default {
    name: 'HelpPage',
    components: {
      ListGroup,
      ListItem,
      Tab,
      TabBtn,
      TabContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/HelpCategory35.vue